export const getters = {
  tokens (state) {
    return state.tokens
  },
  token (state) {
    return state.token
  },  
  pagination(state){
    return state.pagination
  }
}
